module.exports = __webpack_public_path__ + "img/l4.98f4ad1d.png";